export default {"src":"/_next/static/media/etc.e242ea39.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};